module.exports={
    "areg": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "   1. Open the Paypal APP or Paypal official website, click payment, and then enter the company's Paypal account, type the amount you want to recharge, transfer, please screenshot the successful payment page;",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1.Offline recharge has a better discount than the online recharge, please feel free to contact our VIP customer services to get more information.",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "   2. Send the screenshot picture to our VIP customer services and please tell us your Up account at the same time",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2. Paypal transfer may be delayed for some reasons, please be patient and we will recharge for you as soon as possible. Thank you for your cooperation and sorry again for the inconvenience.",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "   3. We will handle your payment for you as soon as possible. Once the diamonds have been added to you Up account, our VIP Customer Services will inform you immediately and then please enjoy your time in Uplive ",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "الدفع عن طريق Alfamart ",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "الدفع عن طريقCodapay ",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "إعادة الشحن عن طريق My Card",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "إعادة الشحن عن طريق Pay Pal",
        "PayPal充值不可用，是否前往Vip充值？": "لا يُمكن استخدام الشحن عن طريق PayPal حاليًا، تواصل مع خدمة عملاء الVIP للشحن؟",
        "Up号": "رقم الحساب",
        "VIP充值": "VIP recharge service",
        "VIP客服": "VIP Customer Service",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "إعادة الشحن عن طريق XenoPay",
        "bk_atm支付": "الدفع عن طريق bk_atm",
        "bk_card支付": "الدفع عن طريق bk_card",
        "cashu支付": "الدفع عن طريق cashu",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "onecard支付": "الدفع عن طريق onecard",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "لحماية أمان الحساب الخاص بك، تم تفعيل القيود التالية من قِبل PayPal:",
        "交易中": "جارٍ إعادة الشحن",
        "价格": "السعر",
        "信息描述": "تفاصيل الرسالة",
        "充值账号": "إعادة شحن الحساب",
        "公司Paypal账号：": "Detailed offline recharge procedures:",
        "参数错误": "خطأ في المعاملات",
        "取消": "إلغاء",
        "名称：": "Name:",
        "商品": "المنتجات",
        "备注：": "Remarks：",
        "已加赠<%=count%>U钻": "تم إضافة <%=count%> ماسة",
        "微信号": "WeChat ID",
        "微信支付": "Wechat",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "Dear Up users, sorry to inform you that our system is being upgraded and the online recharge service has to be temporarily closed, during the upgrading period, offline recharge will be available and please contact our VIP Customer Services and recharge as usual.",
        "支付结果": "نتيجة عملية الدفع",
        "数据请求失败": "فشل في طلب البيانات",
        "更换Up号充值": "تغيير رقم حساب إعادة الشحن",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "مسموح لكل حساب Up أو حساب PayPal الشحن 5 مرات فقط، إجمالي قيمة الشحن لا يجب أن يتعدى 16000 ماسة؛",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "تنبيه: يُرجى التأكد من صحة إدخال رقم الحساب وذلك لتجنب الخطأ عند إعادة الشحن",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "We are very sorry about the inconvenience we brought you due to the system upgrading.  Exclusive diamond discount policy will be applied in order to send our sincere apology for the inconveniences that what we have caused. Wish you can always have a pleasant time in Uplive!",
        "知道了": "موافق",
        "确定": "تأكيد",
        "确认": "تأكيد",
        "第一步：打开Up直播点击个人主页": "الخطوة الأولى: قُم بفتح تطبيق Up ثم أنقر على الصفحة الشخصية",
        "第二步：查看Up号并输入": "الخطوة الثانية: قُم بالتحقق من رقم الحساب ثم قُم بالدخول",
        "系统公告": "system notification",
        "系统错误": "خطأ بالنظام",
        "线下充值流程：": "Offline recharge process:",
        "网络连接有误, 请稍后再试": "خطأ في الإتصال بالشبكة، يُرجى المحاولة مجددًا في وقت لاحق",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "في حالة ظهور أي مشكلة أثناء عملية الشحن ولم يتم إستلام الماس يُرجى التواصل مع خدمة العملاء من داخل التطبيق",
        "请输入Up号": "قُم بإدخال رقم الحساب",
        "账号：": "Our Paypal account:",
        "购买成功": "نجاح عملية الشراء",
        "输入的Up号不存在": "يجب إدخال رقم الحساب",
        "返回": "رجوع",
        "金额或次数限充": "You have exceeded the daily limit",
        "错误": "خطأ"
    },
    "bnin": {
        "个人隐私条款": "গোপনীয়তার নীতি",
        "为确保您能收到发票等信息，请在此处填写手机号和邮箱。": "আপনার চালান তথ্য পাওয়া নিশ্চিত করতে, এখানে আপনার মোবাইল নম্বর এবং ইমেল ঠিকানা পূরণ করুন।",
        "关于我们": "আমাদের সম্পর্কে",
        "我已阅读以下条款": "আমি নিম্নলিখিত শর্তাবলী পড়েছি",
        "手机号必填": "অবশ্যক",
        "手机号格式不正确，请重新填写": "ফোন নম্বর বিন্যাস ভুল, দয়া করে পুনরায় পূরণ করুন",
        "提交成功": "সফলভাবে দাখিল হয়েছে",
        "支付所需资料": "প্রয়োজনীয় তথ্যের জন্য অর্থ প্রদান করুন",
        "支付条约": "পারিশ্রমিক নীতি",
        "更换Up号充值": "অন্য আইডির জন্য রিচার্জ",
        "知道了": "বুঝেছি",
        "确认": "নিশ্চিত করুন",
        "系统错误": "সিস্টেম ত্রুটি",
        "联系我们": "আমাদের সাথে যোগাযোগ করুন",
        "请输入手机号": "ফোন নম্বর লিখুন",
        "请输入邮箱": "ইমেইল ঠিকানা দিন",
        "赶快购买礼物向主播表达心意吧": "দ্রুত এবং একটি উপহার কিনে আপনার ভরসার ব্যক্তিকে আপনার মনের কথা প্রকাশ করুন।",
        "退款及取消条款": "ফেরত এবং বাতিলের শর্তাবলী",
        "邮箱格式不正确，请重新填写": "মেইলবক্স বিন্যাস ভুল, দয়া করে পুনরায় পূরণ করুন"
    },
    "enus": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "   1. Open the Paypal APP or Paypal official website, click payment, and then enter the company's Paypal account, type the amount you want to recharge, transfer, please screenshot the successful payment page;",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1.Offline recharge has a better discount than the online recharge, please feel free to contact our VIP customer services to get more information.",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "   2. Send the screenshot picture to our VIP customer services and please tell us your Up account at the same time",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2. Paypal transfer may be delayed for some reasons, please be patient and we will recharge for you as soon as possible. Thank you for your cooperation and sorry again for the inconvenience.",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "   3. We will handle your payment for you as soon as possible. Once the diamonds have been added to you Up account, our VIP Customer Services will inform you immediately and then please enjoy your time in Uplive ",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "<%=count%>U diamonds ",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "Alfamart",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "Codapay",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "MyCard",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "Paypal",
        "PayPal充值不可用，是否前往Vip充值？": "Paypal recharge now is unavailable, can you please contact our VIP custom service？",
        "Up号": "Up Account",
        "VIP充值": "VIP recharge service",
        "VIP客服": "VIP Customer Service",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "XenoPay",
        "bk_atm支付": "Bao Kim - ATM",
        "bk_card支付": "Bao Kim - Card",
        "cashu支付": "Cashu",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Please_enter_code_of_the_card": "Please enter code of the card",
        "icard_Please_enter_serial_of_the_card": "Please enter serial of the card",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "OneCard",
        "paytm": "paytm",
        "个人隐私条款": "Privacy Policy",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "For your fund's safety，recharge via PayPal will have these restrictions：",
        "为确保您能收到发票等信息，请在此处填写手机号和邮箱。": "please fill your real phone number and e-mail ",
        "为确保您能收到发票等信息，请在此处填写邮箱。": "please fill your real e-mail ",
        "交易中": "in process....",
        "价格": "Price",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "Use CashCard for charging UDiamond will be exchange according to(<%=currence%><%=real%>=<%=number%>UDiamond) ratio. The final amount of UDiamond you get will be round up and round down.",
        "信息描述": "Description",
        "充值账号": "Account Name",
        "公司Paypal账号：": "Detailed offline recharge procedures:",
        "关于我们": "About us",
        "参数错误": "Parameter Error!",
        "取消": "Cancel",
        "名称：": "Name:",
        "商品": "Item",
        "备注：": "Remarks：",
        "已加赠<%=count%>U钻": "<%=count%>U diamonds offered ",
        "微信号": "WeChat ID",
        "微信支付": "Wechat",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "Dear Up users, sorry to inform you that our system is being upgraded and the online recharge service has to be temporarily closed, during the upgrading period, offline recharge will be available and please contact our VIP Customer Services and recharge as usual.",
        "我已阅读以下条款": "I have read all the terms as followed",
        "手机号必填": "Required ",
        "手机号格式不正确，请重新填写": "The format is not correct, please fill it again ",
        "提交成功": "submit successful",
        "支付所需资料": "payment information",
        "支付条约": "Terms and Conditions",
        "支付结果": "Top-up Result",
        "数据请求失败": "Data Error！",
        "更换Up号充值": "Change Up Account",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "Each Uplive and/or PayPal account could only recharge 5 times/day maximum，and the total recharge amount in one day could not exceed 16000 UDiamonds.",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "Note: Please check your Up Account",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "We are very sorry about the inconvenience we brought you due to the system upgrading.  Exclusive diamond discount policy will be applied in order to send our sincere apology for the inconveniences that what we have caused. Wish you can always have a pleasant time in Uplive!",
        "知道了": "OK",
        "确定": "Confirm",
        "确认": "Confirm",
        "立即充值": "立即充值",
        "第一步：打开Up直播点击个人主页": "Step 1: Click into the Profile Page",
        "第二步：查看Up号并输入": "Step 2: Get your Up Accout and Enter here",
        "系统公告": "system notification",
        "系统错误": "System Error!",
        "线下充值流程：": "Offline recharge process:",
        "网络连接有误, 请稍后再试": "Netword issue, please try again later.",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "联系我们": "Contact us",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "Please contact our customer service if you encounter any problems during the recharge process.",
        "请输入Up号": "Please Enter Up Account",
        "请输入手机号": "Enter phone number",
        "请输入邮箱": "Enter email address",
        "账号：": "Our Paypal account:",
        "购买成功": "Purchase Success",
        "赶快购买礼物向主播表达心意吧": "send gift to the host show your love",
        "输入的Up号不存在": "Your Up Account is not Exist",
        "返回": "Back",
        "退款及取消条款": "Refund and Cancellation",
        "邮箱格式不正确，请重新填写": "The format is not correct, please fill it again ",
        "金额或次数限充": "You have exceeded the daily limit",
        "错误": "Error"
    },
    "hiin": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "1. Paypal App या Paypal की आधिकारिक वेबसाइट को खोलें, भुगतान पर क्लिक करें, और फिर कंपनी के Paypal खाते में प्रवेश करें, उस राशि को दर्ज करें जिसे आप रिचार्ज करना चाहते हैं, और स्थानांतरण करें, कृपया सफल भुगतान पृष्ठ का स्क्रीनशॉट ले;",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1.ऑफ़लाइन रिचार्ज ऑनलाइन रिचार्ज की तुलना में विशेष छूट पर है, कृपया अधिक जानकारी पाने के लिए हमारे वीआईपी ग्राहक सेवाओं से संपर्क करें।",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "2. हमारे वीआईपी ग्राहक सेवाओं को स्क्रीनशॉट चित्र भेजें और कृपया हमें उसी समय अपना UP खाता बताएं",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2. कुछ कारणों से Paypal स्थानान्तरण में देरी हो सकती है, कृपया धैर्य रखें और हम जितनी जल्दी हो सके आपके लिए रीचार्ज करेंगे। आपके सहयोग के लिए धन्यवाद और असुविधा के लिए फिर से खेद है।",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "हम आपकी जमा राशि को आपके UP अकाउंट में जल्द से जल्द जमा कर देंगे l जैसे ही आपके उप अकाउंट U डायमंड्स जोड़े जाएंगे, तब हमारी वीआईपी ग्राहक सेवा आपको तत्काल सूचित करेगी और फिर कृपया अपने समय का आनंद लें l",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "<%=count%> यू डायमंड्स की पेशकश की",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "Alfamart",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "Codapay",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "MyCard",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "Paypal",
        "PayPal充值不可用，是否前往Vip充值？": "Paypal रिचार्ज अभी अनुपलब्ध है, क्या आप कृपया हमारी वीआईपी ग्राहक सेवा से संपर्क कर सकते हैं?",
        "Up号": "Up खाता",
        "VIP充值": "VIP recharge service",
        "VIP客服": "वीआईपी ग्राहक सेवा",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "XenoPay",
        "bk_atm支付": "Bao Kim - ATM",
        "bk_card支付": "Bao Kim - Card",
        "cashu支付": "Cashu",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "OneCard",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "आपके राशि की सुरक्षा के लिए, Paypal के माध्यम से रिचार्ज यह प्रतिबंदक हैं l",
        "交易中": "प्रक्रिया में",
        "价格": "क़ीमत",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "U डायमंड्स चार्ज करने के लिए कैशकार्ड का उपयोग करें (<%= currence%> <%= real%> = <%= number%> U डायमंड्स) अनुपात के अनुसार किया जाएगा। डायमंड्स की अंतिम राशि आपको मिलती-जुलती और काम ज्यादा हो सकती हैं l",
        "信息描述": "विवरण",
        "充值账号": "खाते का नाम",
        "公司Paypal账号：": "विस्तृत ऑफ़लाइन रीचार्ज की प्रक्रियाओं:",
        "参数错误": "मापदण्ड गलति !",
        "取消": "रद्द करें",
        "名称：": "नाम:",
        "商品": "वस्तु",
        "备注：": "टिप्पणियाँ:",
        "已加赠<%=count%>U钻": "<%=count%> यू डायमंड्स की पेशकश की",
        "微信号": "WeChat ID",
        "微信支付": "Wechat",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "प्रिय ग्राहक, आपको सूचित करते हुए हमें खेद कि हमारी प्रणाली में सुधार किया जा रहा है और सुधार होने की अवधि के दौरान ऑनलाइन रिचार्ज सेवा को अस्थायी रूप से बंद कर दिया गया है, ऑफ़लाइन रिचार्ज उपलब्ध हैं इसके लिए कृपया वीआईपी ग्राहक सेवा से संपर्क करें और सामान्य रूप से रीचार्ज कराए ।",
        "支付结果": "टॉप-अप का परिणाम",
        "数据请求失败": "डाटा Error !",
        "更换Up号充值": "Up खाता बदलें",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "प्रत्येक और Uplive / या Paypal खाता केवल 5 गुना / दिन अधिकतम रिचार्ज कर सकता है, और एक दिन में कुल रिचार्ज राशि 16000 डायमंड्स से अधिक नहीं हो सकती।",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "नोट: कृपया अपना UP खाता जांचें",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "रूकावट के लिए खेद हैं क्युकि आवेदन प्रणाली में बदलाव किया जा रहा हैं l विशेष डायमंड्स पे छूटनीति लागू कर दी जाएगी, जिस कारण आपको रुकावटे आयी हैं l उम्मीद करते हैं की आप UP लाइव पे अपना अच्छा समय बिताये l",
        "知道了": "ठीक है",
        "确定": "की पुष्टि करें",
        "确认": "की पुष्टि करें",
        "立即充值": "तुरंत रिचार्ज",
        "第一步：打开Up直播点击个人主页": "1 चरण: प्रोफ़ाइल पृष्ठ पर क्लिक करें",
        "第二步：查看Up号并输入": "2 चरण: अपना अप खाता प्राप्त करें और यहां दर्ज करें",
        "系统公告": "सिस्टम अधिसूचना",
        "系统错误": "प्रणाली Error !",
        "线下充值流程：": "ऑफ़लाइन रीचार्ज की प्रक्रिया:",
        "网络连接有误, 请稍后再试": "Network समस्या, कृपया थोड़ी देर बाद पुन: कोशिश करें।",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "अगर आपको रिचार्ज प्रक्रिया के दौरान कोई समस्या आती है तो कृपया हमारे ग्राहक सेवा से संपर्क करें।",
        "请输入Up号": "कृपया UP खाता दर्ज करें",
        "账号：": "हमारा Paypal खाता:",
        "购买成功": "सफलता पूर्वक खरीद",
        "输入的Up号不存在": "आपका UP खाता मौजूद नहीं है",
        "返回": "वापस",
        "金额或次数限充": "आपने दैनिक सीमा पार कर ली है",
        "错误": "ग़लती"
    },
    "idid": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "1. Buka klien Paypal atau halaman web Paypal, klik untuk bayar, kemudian masuk rekening Paypal perusahaan, pilih dana yang anda ingin isi pulsa, melakukan transfer, sukses transfer silahkan screeshot dan beri bukti;",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1. Bonus pengantaran berlian isi pulsa offline lebih bagus daripada isi pulsa online, peraturan bonus spesifik silahkan tanya pelayan VIP;",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "Antar ke pada pelayan VIP(Kalau sementara tiada, boleh pilih sebarang satu pelayan VIP di berikut), dan memberi nomor Up anda;",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2. Karena harus mengesahkan adakah sudah sampai ke rekening, jadi penyampaian berlian mungkin akan dilewati, tapi kami akan isi pulsa dengan laju paling cepat, silahkan faham.",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "3. Selepas verifikasi perusahaan sampai rekening, akan segera antar berlian kepada anda, dan akan mengumumkan melalui pelayan VIP bahwa berlian sudah sukses diantarkan.",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "<%=count%> U diamond",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "Bayar Alfamart",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "Pulsa,ATM,Lain",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "Isi pulsa MyCard",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "Isi pulsa PayPal",
        "PayPal充值不可用，是否前往Vip充值？": "Isi pulsa PayPal tidak tersedia, ingin pergi isi pulsa Vip?",
        "Up号": "Nomor Up",
        "Up号:": "Up ID",
        "VIP充值": "VIP recharge service",
        "VIP客服": "Pelayanan VIP",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "Bayar XenoPay",
        "bk_atm支付": "Bayar bk_atm",
        "bk_card支付": "Bayar bk_card",
        "cashu支付": "Bayar cashu",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "Bayar onecard",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "Demi keamanan akun Anda, mohon baca ketentuan top up PayPal:",
        "云智联网络科技": "Teknologi internet Yunzhilian",
        "交易中": "Dalam transaksi",
        "价格": "Harga",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "Jumlah U diamond yang ditop up dengan CashCard akan ditukarkan dengan kurs pertukaran (<%=currence%><%=real%>=<%=number%>Koin U), dan akan dibulatkan.",
        "使用CashCard充值的金额数以点卡实际支付的金额为准": "\nNominal Top up dengan CashCard sesuai dengan nominal pembayaran voucher aktual",
        "信息描述": "Deskripsi informasi",
        "储值服务时间详情": "Detail waktu pelayanan simpanan:",
        "储值服务时间：": "Waktu pelayanan simpanan:",
        "充值信息": "Informasi isi pulsa",
        "充值方式": "Cara isi pulsa",
        "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "\nKurs Pertukaran:<%=currence%><%=real%>=<%=number%>Koin U",
        "充值账号": "Rekening isi pulsa",
        "充值账号：请仔细核对Up账号是否正确，以避免充值错误": "Rekening isi pulsa: Silahkan semak nomor rekenign Up betul atau tidak, untuk mengelakkan salah isi pulsa.",
        "充值账户:": "Rekening isi pulsa",
        "充值金额": "Dana isi pulsa",
        "充值额度:": "Kuotasi isi pulsa",
        "公司Paypal账号：": "Nomor rekening Paypal perusahaan:",
        "参数错误": "Salah parameter",
        "发票信息": "Informasi faktur",
        "取消": "Batal",
        "名称：": "Nama",
        "商品": "Barang",
        "备注：": "Catatan:",
        "小贴士": "Tips",
        "已加赠<%=count%>U钻": "Bonus <%=count%> U diamond",
        "微信号": "Nomor wechat",
        "微信支付": "Bayar Wechat",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "Apa kabar, karena pemeliharaan upgrade sistem, sementara mematikan fungsi pengisian ulang online, Anda dapat mentransfer ke akun perusahaan, dan melalui layanan VIP untuk mendapatkan koin u.",
        "慈善捐款": "Derma amal",
        "慈善捐赠解释": "Keterangan derma amal",
        "户名": "Nama rekening",
        "提交，去支付": "Antar, pergi bayar",
        "支付结果": "Hasil pembayaran",
        "数据请求失败": "Gagal permintaan data",
        "更换Up号充值": "Ganti Up ID",
        "最优": "Terbagus",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "Setiap akun Uplive atau PayPal hanya dapat melakukan top up 5 kali per hari, dan jumlah top up maksimal 16000 U diamond;",
        "永兴银行": "Bank Yongxing",
        "汇款注意事项": "Hal perhatian transfer",
        "汇款账户": "Rekening transfer",
        "汇款账户信息": "Informasi rekening transfer",
        "汇款金额": "Dana transfer",
        "注意事项详情": "Detail hal-hal perhatian",
        "注意事项：": "Hal-hal perhatian:",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "Perhatian: Mohon pastikan Up ID yang Anda isi benar, supaya top up berhasil",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "Untuk ketidaknyamanan yang mendatangkan kepada anda, kami akan memberi Anda konsesi hadiah bonus yang lebih besar, dan semoga Anda selamat di Up, berikut ini adalah proses yang terperinci.",
        "电话号码格式错误": "Salah format nomor tel",
        "知道了": "Saya tahu",
        "确定": "Konfirm",
        "确认": "Konfirm",
        "确认充值": "Konfirm Isi pulsa",
        "立即充值": "Isi ulang segera",
        "第一步：打开Up直播点击个人主页": "Langkah 1: Buka halaman profil Uplive",
        "第二步：查看Up号并输入": "Langkah 2: Cek Up ID dan memasukkan di atas",
        "系统公告": "Pengumuman sistem",
        "系统异常": "Abnormal sistem",
        "系统错误": "Salah sistem",
        "索取发票": "Minta faktur",
        "索取发票解释": "Keterangan minta faktur",
        "线下充值流程：": "Proses isi pulsa offline:",
        "网络连接有误, 请稍后再试": "Salah sambung internet, silakan coba semula nanti",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "Jika ada U diamond tidak masuk ke akun Anda setelah top up, mohon langsung hubungi CS melalui aplikasi Uplive.",
        "请您于24小时内通过线下银行汇款的方式转账至上述银行账户，逾期将无法付款成功": "Silahkan transfer ke rekening bank melalui cara transfer bank offline dalam 24 jam, kalau kelewatan waktu tidak mampu sukses bayar",
        "请输入Up号": "Silakan memasukkan Up ID",
        "请输入e-mail地址": "Silahkan masuk email",
        "请输入住宅地址": "Silahkan masuk alamat pendiaman",
        "请输入真实姓名": "Silahkan masuk nama benar",
        "请输入联系电话": "Silahkan masuk nomor telefon",
        "账号：": "Nomor rekening:",
        "购买成功": "Sukses bayar",
        "输入的Up号不存在": "Nomor Up yang masuk tidak tersedia",
        "返回": "Kembali",
        "选择银行": "Pilih bank",
        "邮箱格式错误": "Salah format email",
        "金额或次数限充": "Dana atau batasan kali isi pulsa",
        "银行代码": "Kode bank",
        "银行名称": "Nama bank",
        "银行汇款": "Transfer bank",
        "银行汇款到账提示详情": "Detail peringatan sampai transfer bank",
        "错误": "Salah",
        "需支付": "Harus bayar"
    },
    "jajp": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "1、PaypalのアプリまたはPaypalのウェブサイトを利用してください。「支払い」をクリックして、会社のPaypal口座を入力してください。そこて、チャージしたい金額を選択して、振り込みしてください。振り込みが終わったあと、証拠として画面をキャプチャしてください。",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1、VIPカスタマーサポートを利用してチャージする場合、他の方法よりもっとたくさんのダイヤをもらえます。詳しい情報はVIPカスタマーサポートにお問い合わせください。",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "2、キャプチャした画像と貴方のUpアカウントをVIPカスタマーサポートに送ってください。（始めてこの機能を使う方は、ご覧のVIPカスタマーサポートからご自由で選んでください）。",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2、振り込みの確認には少し時間がかかります。ご理解のほどよろしくお願いいたします。",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "3、振り込みを確認したあと、すぐダイヤを追加して、VIPカスタマーサポートからお知らせします。",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "Alfamart",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "Codapay",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "MyCard",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "Paypal",
        "PayPal充值不可用，是否前往Vip充值？": "PayPalでチャージできません！VIPカスタマーサポートを利用してチャージしませんか？",
        "Up号": "Upアカウント",
        "VIP充值": "VIP recharge service",
        "VIP客服": "VIP Customer Service",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "XenoPay",
        "bk_atm支付": "Bao Kim - ATM",
        "bk_card支付": "Bao Kim - Card",
        "cashu支付": "Cashu",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "OneCard",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "安全なインターネットショッピングのため、下記のルールを守って頂きます：",
        "交易中": "処理中",
        "价格": "価格",
        "信息描述": "説明",
        "充值账号": "アカウント名",
        "公司Paypal账号：": "会社のPaypal口座：",
        "参数错误": "数値エラー",
        "取消": "取り消し",
        "名称：": "Name:",
        "商品": "アイテム",
        "备注：": "备考：",
        "已加赠<%=count%>U钻": "<%=count%>ダイヤボーナス入り",
        "微信号": "WeChat ID",
        "微信支付": "Wechat",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "システムメンテナンス中なので、オンラインチャージ機能が一時的に停止されました。チャージしたい場合、VIPカスタマーサポートを利用して下さい。ご迷惑をおかけして申し訳ございませんでした。",
        "支付结果": "購入結果",
        "数据请求失败": "データエラー",
        "更换Up号充值": "Upアカウントを変更する",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "同じUpアカウントまたはPayPal口座は、毎日最大５回チャージが出来ます。また、最大総合16000ダイヤをチャージ出来ます。",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "注意：Upアカウントを確認してください",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "お詫びにカスタマサポートを使用する方に大量のダイヤボーナスを贈ります！これからも、Upを楽しんでください。詳しいことは下のようです。",
        "知道了": "OK",
        "确定": "はい",
        "确认": "確定",
        "第一步：打开Up直播点击个人主页": "ステップ1: プロフィールページに入る",
        "第二步：查看Up号并输入": "ステップ2: Upアカウントを確認し、ここで入力する",
        "系统公告": "お知らせ",
        "系统错误": "システムエラー",
        "线下充值流程：": "チャージ方法:",
        "网络连接有误, 请稍后再试": "通信エラーです。再度お試しください",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "チャージ後ダイヤが振り込まれていない場合、Appのなかでカスタマーサポートまでお問い合わせください。",
        "请输入Up号": "Upアカウントを入力してください",
        "账号：": "Our Paypal account:",
        "购买成功": "購入成功",
        "输入的Up号不存在": "Upアカウントが存在しません",
        "返回": "戻る",
        "金额或次数限充": "You have exceeded the daily limit",
        "错误": "エラー"
    },
    "kokr": {
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Bank Payments": "Bank Payments",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "MoMo": "MoMo",
        "Up号": "Up계정",
        "VIP充值": "VIP recharge service",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "고객님의 자금안전을 위해, paypal에서 충전하는 것은 제한을 받을 수 있습니다.\n",
        "交易中": "처리중",
        "价格": "가격",
        "信息描述": "설명",
        "商品": "아이템",
        "支付结果": "충전 결과",
        "数据请求失败": "데이터 오류!",
        "更换Up号充值": "Up계정 수정",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "모든 Up 계정이나 Paypal 계정은 매일 최대 충전 횟수가 5회이며, 총 충전수가 16000 U 다이아몬드를 초과할 수 없습니다.",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "알림: Up계정을 확인하세요!",
        "确认": "확인",
        "第一步：打开Up直播点击个人主页": "1단계: 나의 프로필 페이지를 클릭하세요",
        "第二步：查看Up号并输入": "2단계: Up계정을 확인하시고 여기에 기입하세요",
        "系统错误": "시스템 오류",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "충전을 하고 U 다이아몬드를 받지 못했을 때, App 고객 서비스 센터에 연락 해 주세요.",
        "请输入Up号": "Up계정을 기입하세요",
        "购买成功": "구매 완료",
        "输入的Up号不存在": "고객님의 Up계정이 존재하지 않습니다",
        "返回": "뒤로",
        "错误": "오류"
    },
    "msmy": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "1. Buka APP Paypal atau laman web rasmi Paypal, klik pembayaran, dan kemudian masukkan akaun Paypal syarikat, ketikkan jumlah yang anda ingin cas semula, pindahkan, sila tangkapkan halaman pembayaran yang berjaya;",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1, Top up dengan customer servIce Vip akan dapat lebih ganjaran.",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "2, Sila anda screenshot resit transaksi dan Up ID anda dan hantar kepada Customer Service Vip Kita",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2, Untuk mengesahkan akaun anda, jadi penggerudian akan sedikit kelewatan, tetapi kami akan cepatkan untuk membantu anda Top Up, Harap Maaf.",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "3, Apabila kita comfirm transaksi anda,kita akan top up segera dan akan memberitahu melalui customer service Vip",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "<%=count%> U Dril",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "top up Alfamart",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "top up Codapay",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "top up MyCard",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "top up PayPal",
        "PayPal充值不可用，是否前往Vip充值？": "Palpal top up tidak berfunsi,guna Top Up VIP?",
        "Up号": "akaun UP",
        "Up号:": "Up ID",
        "VIP充值": "VIP recharge service",
        "VIP客服": "VIP Customer Service",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "Top up XenoPay",
        "bk_atm支付": "top up bk_atm",
        "bk_card支付": "top up bk_atm",
        "cashu支付": "top up canshu",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "top up one card",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "Untuk melindungi keselamatan modal anda, PayPal akan melakukan sekatan berikut:",
        "交易中": "Dalam transaksi",
        "价格": "harga",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "Jumlah wang U yang diperolehi menggunakan CashCard top up akan berdasarkan pada nisbah penukaran (<%=currence%><%=real%>=<%=number%>wang u)Dan jumlah akhir wang U akan dibulatkan",
        "使用CashCard充值的金额数以点卡实际支付的金额为准": "Jumlah wang yang dikenakan dengan CashCard adalah berdasarkan jumlah yang sebenarnya dibayar oleh kad",
        "信息描述": "infomasi",
        "储值服务时间详情": "Butiran perkhidmatan yang disimpan",
        "储值服务时间：": "Masa perkhidmatan penyimpanan:",
        "充值信息": "mesej top up",
        "充值方式": "kaedah top up",
        "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "Ratio top up:<%=currence%><%=real%>=<%=number%>wang U",
        "充值账号": "akaun top up",
        "充值账号：请仔细核对Up账号是否正确，以避免充值错误": "Akaun pajakan: Sila semak akaun Up dengan betul, untuk mengelakkan ralat pengecasan",
        "充值账户:": "akaun top up",
        "充值金额": "jumlah top up",
        "充值额度:": "Limit top up",
        "公司Paypal账号：": "Prosedur mengisi semula luar talian terperinci:",
        "参数错误": "kesalahan parameter",
        "发票信息": "mesej resit",
        "取消": "batalkan",
        "名称：": "nama:",
        "商品": "Komoditi",
        "备注：": "Remarks：",
        "小贴士": "informasi",
        "已加赠<%=count%>U钻": "Ditambah <%=count%> U Dril",
        "微信号": "WeChat ID",
        "微信支付": "wechat",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "Pengguna yang dihormati, maaf untuk memaklumkan kepada anda bahawa sistem kami sedang dinaik taraf dan perkhidmatan caj dalam talian terpaksa ditutup sementara, semasa tempoh peningkatan, pengecasan luar talian akan tersedia dan sila hubungi Perkhidmatan Pelanggan VIP kami dan cas semula seperti biasa.",
        "慈善捐款": "derma amal",
        "慈善捐赠解释": "penerangan derma amal",
        "户名": "name pengguna",
        "提交，去支付": "hantar,bayar",
        "支付结果": "keputusan bayaran",
        "数据请求失败": "Permintaan data gagal",
        "更换Up号充值": "tukar Akaun UP untuk top up",
        "最优": "Terbaik",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "Akaun Setiap Up atau akaun PayPal dihadkan kepada 5 kali sehari, dan jumlah cas semula tidak dapat melebihi 16000U;",
        "汇款注意事项": "Nota pengiriman wang",
        "汇款账户": "Akaun pengiriman wang",
        "汇款账户信息": "Maklumat akaun pengiriman wang",
        "汇款金额": "jumlah",
        "注意事项详情": "Butiran notis",
        "注意事项：": "nota",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "Nota: Sila semak dengan teliti sama ada nombor Up yang betul, untuk mengelakkan ralat pengecasan.",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "Kami sangat menyesal tentang kesulitan yang kami bawa kepada anda kerana peningkatan sistem. Dasar diskaun eksklusif berlian akan digunakan untuk menghantar permohonan maaf secara ikhlas untuk kesulitan yang telah kami lakukan. Ingin anda sentiasa mempunyai masa yang menyenangkan di Uplive!",
        "电话号码格式错误": "Peti mel yang salah",
        "知道了": "ok",
        "确定": "ok",
        "确认": "ok",
        "确认充值": "ok",
        "立即充值": "Top up Segera",
        "第一步：打开Up直播点击个人主页": "Langkah 1: Buka Klik UP Live di halaman utama peribadi",
        "第二步：查看Up号并输入": "Langkah 2: Lihat nombor Up dan masukkannya",
        "系统公告": "Mesej sistem",
        "系统异常": "Pengecualian sistem",
        "系统错误": "kesalahan sistem",
        "索取发票": "Minta invois",
        "索取发票解释": "Penerangan Minta invois",
        "线下充值流程：": "Offline Top up process:",
        "网络连接有误, 请稍后再试": "Sambungan rangkaian adalah salah, sila cuba lagi kemudian",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "Sekiranya wang U pengecasan tidak tiba, sila hubungi khidmat pelanggan rasmi di dalam App;\n",
        "请您于24小时内通过线下银行汇款的方式转账至上述银行账户，逾期将无法付款成功": "Sila pindahkan akaun bank anda ke akaun bank anda dalam masa 24 jam melalui pemindahan bank luar talian.",
        "请输入Up号": "sila masukkan Akaun UP",
        "请输入e-mail地址": "sila masukkan email address",
        "请输入住宅地址": "sila masukkan alamat",
        "请输入真实姓名": "sila masukkan nama mengikut I/C",
        "请输入联系电话": "sila masukkan nombor telefon",
        "账号：": "Akaun Paypal kami:",
        "购买成功": "pambelian berjaya",
        "输入的Up号不存在": "Nombor yang dimasukkan tidak wujud",
        "返回": "kembali",
        "选择银行": "pilih bank",
        "金额或次数限充": "Limit top up",
        "银行代码": "Kod bank",
        "银行名称": "nama bank",
        "银行汇款": "Penghantaran bank",
        "银行汇款到账提示详情": "Butiran kiriman wang bank",
        "错误": "salah",
        "需支付": "perlu bayar"
    },
    "thth": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "1. เปิดPaypal APPหรือ Paypal official website แล้วกดชำระเงิน จากนั้นใส่บัญชีPaypal บริษัทลงไป เลือกจำนวนเงินที่คุณต้องการเติม เข้าสู่การโอนเงิน หลังการโอนเงินสำเร็จโปรดแคปหน้าจอเก็บไว้เป็นหลักฐาน",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1.เพชรราคาพิเศษจากการเติมเงินแบบออฟไลน์จะได้มากกว่าการเติมเงินแบบออนไลน์ ข้อกำหนดของราคาพิเศษสามารถสอบถามได้ที่ทีมงานVIP",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "2、นำหลักฐานการโอนเงินที่บันทึกหน้าจอไว้ส่งมาให้ทีมงานVIP（หากไม่มี โปรดเลือกทีมงานVIPใดๆเพื่อเพิ่ม）และแสดงเลขที่Up",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2. เนื่องจากต้องมีการตรวจสอบว่าถึงบัญชีหรือไม่ ดังนั้นการแจกเพชรจึงเกิดความล่าช้า แต่ทางเราจะรีบดำเนินการให้คุณ ขออภัยในความไม่สะดวก",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "3.หลังจากบริษัทตรวจสอบแล้ว จะให้เพชรแก่คุณทันทีและทีมงานVIPจะแจ้งให้คุณทราบ",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "<%=count%>เพชรU",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "จ่ายด้วยAlfamart",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "จ่ายด้วยCodapay",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "เติมเงินMyCard",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "เติมเงินPayPal",
        "PayPal充值不可用，是否前往Vip充值？": "ไม่สามารถใช้เติมเงินPayPalได้ ไปยังการเติมเงินVip？",
        "Up号": "เลขที่Up",
        "Up号:": "เลขที่Up:",
        "VIP充值": "VIP recharge service",
        "VIP客服": "ทีมงานVIP",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "XenoPay",
        "bk_atm支付": "จ่ายด้วยbk_atm",
        "bk_card支付": "จ่ายด้วยbk_card",
        "cashu支付": "จ่ายด้วยcashu",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "จ่ายด้วยonecard",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "เพื่อรับรองความปลอดภัยเงินทุนของท่าน การเติมเงินด้วย Paypal จึงมีข้อจำกัดดังนี้",
        "云智联网络科技": "WangyiรับบริการATM",
        "交易中": "กำลังดำเนินการ",
        "价格": "ราคา",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "Diamond ที่ได้จากการเติมเงินผ่าน Cash Card จะแปลงตามสัดส่วนอัตราแลกเปลี่ยน (<%=real%><%=currence%>=<%=number%>Diamond) สุดท้ายจะปัดเศษ Diamond ที่ได้",
        "使用CashCard充值的金额数以点卡实际支付的金额为准": "ยอดเงินCashcardที่สามารถใช้ได้ จะยึดจากจำนวนเงินที่มีในบัตรเป็นหลัก",
        "信息描述": "รายละเอียด",
        "储值服务时间详情": "ธนาคารAPPโอนเงินฝากเงินตลอด24ชม.@@@@ธนาคารทางอินเตอร์เน็ตโอนเงินฝากเงินตลอด 24ชม.@@@@ATMโอนเงินฝากเงินตลอด24ชม.@@@@ธนาคารโอนเงินฝากเงินในเวลา 9:00 - 15:30น.@@@@ไปรษณีย์โอนเงินฝากเงินในเวลา 8:00 - 17:00น.",
        "储值服务时间：": "เวลาทำการ：",
        "充值信息": "ข้อมูลเติมเงิน",
        "充值方式": "วิธีเติมเงิน",
        "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "สัดส่วนอัตราแลกเปลี่ยน：<%=real%><%=currence%>=<%=number%>Diamond",
        "充值账号": "ชื่อบัญชี",
        "充值账号：请仔细核对Up账号是否正确，以避免充值错误": "ข้อควรระวัง：โปรดตรวจสอบความถูกต้องของ Up ID เพื่อลดความผิดพลาดในการเติมเงิน",
        "充值账户:": "บัญชีเติมเงิน:",
        "充值金额": "จำนวนที่เติม",
        "充值额度:": "จำนวนที่เติม:",
        "公司Paypal账号：": "บัญชีPaypalบริษัท：",
        "参数错误": "ข้อมูลผิดพลาด",
        "发票信息": "ข้อมูลInvoice",
        "取消": "ยกเลิก",
        "名称：": "ชื่อ：",
        "商品": "ไอเทม",
        "备注：": "หมายเหตุ：",
        "小贴士": "Tips",
        "已加赠<%=count%>U钻": "เพิ่มแจก<%=count%>เพชรU",
        "微信号": "วีแชทไอดี",
        "微信支付": "วีแชท เพย์",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "ผู้ใช้งานที่รัก เนื่องจากระบบอยู่ในระหว่างการปรับปรุงอัพเดท จึงทำให้ต้องปิดฟังก์ชั่นการเติมเงินในขณะนี้ คุณสามารถโอนเงินไปยังบัญชีบริษัทและรับเพชรUผ่านทีมงานVIP",
        "慈善捐款": "บริจาค",
        "慈善捐赠解释": "<em>1.การบริจาค：</em>เราจะนำการบริจาคนี้ไปให้กับองค์กรพิทักษ์ปกป้องสัตว์แห่งสาธารณรัฐประชาชนจีน ขอบคุณ เว็บไซต์：http://apatw.org/",
        "户名": "ชื่อบัญชี",
        "提交，去支付": "ส่ง ไปจ่ายเงิน",
        "支付结果": "ผลการชำระเงิน",
        "数据请求失败": "ข้อมูลที่ขอผิดพลาด",
        "更换Up号充值": "เปลี่ยน Up ID เติมเงิน",
        "最优": "ดีที่สุด",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "บัญชี Uplive หรือบัญชี Paypal ทุกบัญชีจำกัดการเติมวันละ 5 ครั้ง และจำนวนที่เติมไม่สามารถเกิน 16000 Diamond\n",
        "永兴银行": "ธนาคารSinoPac",
        "汇款注意事项": "ข้อระวังในการโอนเงิน",
        "汇款账户": "เลขที่บัญชี",
        "汇款账户信息": "ข้อมูลบัญชี",
        "汇款金额": "จำนวนที่โอน",
        "注意事项详情": "<em>1.</em> ใช้บัตรธนาคารใดๆเพื่อโอนไปยังธนาคารอื่น ถอนเงินATMเพื่อโอนคิดร่าบริการ15หยวน@@@@<em>2.</em> ใช้บัตรธนาคารใดๆเพื่อโอนไปยังธนาคารเดียวกัน ถอนเงิน ATM เพื่อโอนไม่คิดค่าบริการ @@@@<em>3.</em> บัญชีใดๆจะมีผลเพียง24ชม. หากเกินกำหนดจะโอนเงินไม่สำเร็จ@@@@<em>4.</em> ใช้ได้ทุกวันไม่เว้นวันหยุด 24ชม.@@@@<em>5.</em> สาขา: ธนาคาร SinoPac สาขาTaipei",
        "注意事项：": "ข้อระวัง",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "ข้อควรระวัง：โปรดตรวจสอบความถูกต้องของ Up ID เพื่อลดความผิดพลาดในการเติมเงิน",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "ขออภัยในความไม่สะดวกของคุณ เราจะแจกเพชรราคาพิเศษ เพื่อให้ท่านได้เล่นUpอย่างมีความสุข กระบวนการมีดังนี้",
        "电话号码格式错误": "รูปแบบหมายเลขโทรศัพท์ผิดพลาด",
        "知道了": "รับทราบ",
        "确定": "ตกลง",
        "确认": "ตกลง",
        "确认充值": "ยืนยันเติมเงิน",
        "立即充值": "เติมเงินทันที",
        "第一步：打开Up直播点击个人主页": "ขั้นที่1：เปิดUpเติมเงินแล้วกดที่หน้าโปรไฟล์",
        "第二步：查看Up号并输入": "ขั้นที่2： นำ Up ID ตามภาพมากรอก",
        "系统公告": "ประกาศระบบ",
        "系统异常": "ระบบผิดปกติ",
        "系统错误": "ระบบผิดพลาด",
        "索取发票": "Invoice",
        "索取发票解释": "<em>2.Invoice：</em>เราจะส่งInvoiceไปยังอีเมล์ของท่านภายใน15วันทำการ！",
        "线下充值流程：": "กระบวนการเติมเงินออฟไลน์：",
        "网络连接有误, 请稍后再试": "เชื่อมต่อเครือข่ายผิดพลาด โปรดลองใหม่ภายหลัง",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "หากในกรณีเติมเงินแล้วไม่ได้รับ Diamond โปรดติดต่อฝ่ายบริการลูกค้าภายใน App\n",
        "请您于24小时内通过线下银行汇款的方式转账至上述银行账户，逾期将无法付款成功": "โปรดดำเนินการโอนเงินไปยังบัญชรที่ระบุภายใน24ชม. หากเกินเวลาจะไม่สามารถจ่ายเงินได้สำเร็จ",
        "请输入Up号": "โปรดใส่ Up ID",
        "请输入e-mail地址": "โปรดใส่Email",
        "请输入住宅地址": "โปรดใส่ที่อยู่",
        "请输入真实姓名": "โปรดใส่ชื่อจริงของคุณ",
        "请输入联系电话": "โปรดใส่หมายเลขโทรศัพท์",
        "账号：": "บัญชี：",
        "购买成功": "ซื้อสำเร็จ",
        "输入的Up号不存在": "ไม่พบเลขที่Upที่ใส่",
        "返回": "กลับ",
        "选择银行": "เลือกธนาคาร",
        "邮箱格式错误": "รูปแบบอีเมล์ผิดพลาด",
        "金额或次数限充": "เกิดขีดจำกัดของวันนี้",
        "银行代码": "รหัสธนาคาร",
        "银行名称": "ชื่อธนาคาร",
        "银行汇款": "ธนาคารโอนเงิน",
        "银行汇款到账提示详情": "<em>1.</em>ธนาคารทางอินเตอร์เน็ตเพื่อโอนเงินฝากเงิน ATMฝากเงินปกติจะใช้เวลา1ถึงบัญชี5~60นาท การโอนเงินด้วยวิธีการอื่นจะอยู่ในเวลา：วันจันทร์ถึงวันพฤหัสบดีหลังเวลา15:30น.จะถึงบัญชีนวันถัดไป วันศุกร์หลัง15 : 30น. จะถึงบัญชีในวันจันทร์@@@@<em>2.</em> เพื่อรักษาผลประโยชร์ของตน หลังโอนเงินแล้วโปรดเก็บหลักฐานการโอน@@@@<em>3.</em> ในระหว่างการฝากเงิน หากพบปัญหาโปรดติดต่อทีมงาน@@@@<em>4.</em>จำนวนที่ฝากเงินจะเปลี่ยนไปเป็นเหรียญภายในเกมส์ในหนึ่งครั้ง ไม่สามารถแยกบัญชีหรือเติมหลายครั้งในบัญชีเดียวกันได้",
        "错误": "ผิดพลาด",
        "需支付": "ต้องไปจ่าย"
    },
    "vivn": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "   1. Open the Paypal APP or Paypal official website, click payment, and then enter the company's Paypal account, type the amount you want to recharge, transfer, please screenshot the successful payment page;",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1.Offline recharge has a better discount than the online recharge, please feel free to contact our VIP customer services to get more information.",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "   2. Send the screenshot picture to our VIP customer services and please tell us your Up account at the same time",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2. Paypal transfer may be delayed for some reasons, please be patient and we will recharge for you as soon as possible. Thank you for your cooperation and sorry again for the inconvenience.",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "   3. We will handle your payment for you as soon as possible. Once the diamonds have been added to you Up account, our VIP Customer Services will inform you immediately and then please enjoy your time in Uplive ",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "Nhận được: <%=count%> kim cương ",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "Nạp Alfamart",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "Nạp Codapay",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "Nạp MyCard",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "Nạp PayPal",
        "PayPal充值不可用，是否前往Vip充值？": "Cổng nạp PayPal hiện tạm khoá, vui lòng liên hệ CS để biết thêm chi tiết",
        "Up号": "Tên Uplive ",
        "Up号:": "Tên Uplive",
        "VIP充值": "VIP recharge service",
        "VIP客服": "VIP Customer Service",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "Nạp XenoPay",
        "bk_atm支付": "Nạp ATM ",
        "bk_card支付": "Nạp Thẻ Cào",
        "cashu支付": "Nạp Cashu",
        "iCard": "Thẻ cào",
        "icard_Code": "Mã thẻ",
        "icard_Please_enter_code_of_the_card": "Nhập mã thẻ...",
        "icard_Please_enter_serial_of_the_card": "Nhập số se-ri...",
        "icard_Serial": "Số se-ri",
        "icard_cardType": "Nhà mạng",
        "icard_cardValue": "Mệnh giá",
        "icard_popup_confirm_title": "Thông tin bên dưới là chính xác?",
        "icard_popup_no": "Nhập lại",
        "icard_popup_yes": "Xác nhận",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "Nạp OneCard",
        "paytm": "paytm",
        "pepay_entitycard": "Nạp tiền qua thẻ",
        "pepay_onlinebank": "Naạp tiền qua ngân hàng trực tuyến",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "Để đảm bảo an toàn cho bạn，PayPal sẽ có những quy định hạn chế sau：",
        "云智联网络科技": "Công ty AIG ",
        "交易中": "Đang giao dịch",
        "价格": "Giá",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "Số KC được nạp qua CashCard được quy đổi theo tỉ lệ (vd: c), cuối cùng KC sẽ được làn tròn. ",
        "使用CashCard充值的金额数以点卡实际支付的金额为准": "Sử dụng số tiền CashCard nạp tiền bằng cách nhấp vào số tiền thực tế",
        "信息描述": "Miêu tả ",
        "储值服务时间详情": "Chi tiết thời gian nạp tiền",
        "储值服务时间：": "Thời gian dịch vụ nạp tiền",
        "充值信息": "Thông tin nạp",
        "充值方式": "Cách nạp tiền",
        "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "Tỉ lệ nạp tiền: \n<%=real%><%=currence%>=<%=number%> KC",
        "充值账号": "Tài khoản nạp ",
        "充值账号：请仔细核对Up账号是否正确，以避免充值错误": "Nap tài khoản: Hãy đối chiếu Tên Uplive đã đúng chưa, để tránh nạp sai",
        "充值账户:": "Tài khoản nạp ",
        "充值金额": "Số tiền nạp",
        "充值额度:": "Mệnh giá nạp",
        "公司Paypal账号：": "Detailed offline recharge procedures:",
        "参数错误": "Tham số lỗi ",
        "发票信息": "Thông tin hóa đơn",
        "取消": "Huỷ",
        "名称：": "Name:",
        "商品": "Vật phẩm",
        "备注：": "Remarks：",
        "小贴士": "Tips",
        "已加赠<%=count%>U钻": "Thêm <%=count%>kim cương ",
        "微信号": "WeChat ID",
        "微信支付": "Wechat",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "Dear Up users, sorry to inform you that our system is being upgraded and the online recharge service has to be temporarily closed, during the upgrading period, offline recharge will be available and please contact our VIP Customer Services and recharge as usual.",
        "慈善捐款": "Nguyên góp từ thiện",
        "慈善捐赠解释": "Giải thích nguyên góp từ thiện",
        "户名": "Tên người dùng",
        "提交，去支付": "Nộp, thanh toán",
        "支付结果": "Kết quả nạp",
        "数据请求失败": "Lỗi mạng",
        "更换Up号充值": "Đổi Tên Uplive",
        "最优": "Tối ưu nhất",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "Mỗi tài khoản Uplive hoặc PayPal chỉ được nạp tối đa 5 lần 1 ngày，giá trị nạp không được vượt quá 16.000KC。",
        "永兴银行": "Ngân hàng Vỉnh Hưng",
        "汇款注意事项": "Chú ý khi chuyển khoản",
        "汇款账户": "Tài khoản chuyển khoản",
        "汇款账户信息": "Thông tin tài khoản chuyển khoản",
        "汇款金额": "Số tiền chuyển khoản",
        "注意事项详情": "Chi tiết cần chú ý",
        "注意事项：": "Chú ý:",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "Chú ý: Kiểm tra kỹ Tên Uplive trước khi nạp. Tránh nạp nhầm tài khoản. ",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "We are very sorry about the inconvenience we brought you due to the system upgrading.  Exclusive diamond discount policy will be applied in order to send our sincere apology for the inconveniences that what we have caused. Wish you can always have a pleasant time in Uplive!",
        "电话号码格式错误": "Số điện thoại bị sai",
        "知道了": "OK",
        "确定": "Xác nhận",
        "确认": "Xác nhận",
        "确认充值": "Xác nhận nạp tiền",
        "立即充值": "Nạp tiền ngay",
        "第一步：打开Up直播点击个人主页": "Bước 1: Mở Uplive chọn trang Hồ Sơ Cá Nhân",
        "第二步：查看Up号并输入": "Bước 2: Nhập tên Uplive",
        "系统公告": "system notification",
        "系统异常": "Hệ thống bị lỗi",
        "系统错误": "Hệ thống lỗi",
        "索取发票": "Tìm hóa đơn",
        "索取发票解释": "Giaỉ thích tìm kiếm hóa đơn",
        "线下充值流程：": "Offline recharge process:",
        "网络连接有误, 请稍后再试": "Mạng lỗi, thử lại sau",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "Contact our VIP customer service for offline recharge and get the extra 3% uDiamond award immediately.",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "Nêú không nhận được kim cương sau khi nạp, vui lòng liên hệ bộ phận chăm sóc khách hàng。",
        "请您于24小时内通过线下银行汇款的方式转账至上述银行账户，逾期将无法付款成功": "Xin mời bạn hãy đến trực tiếp ngân hàng để chuyển khoản đến tài khoản nói trên, nếu quá hạn sẽ không thể chuyển khoản",
        "请输入Up号": "Nhập Tên Uplive ",
        "请输入e-mail地址": "Hãy nhập địa chỉ Email",
        "请输入住宅地址": "Hãy điền địa chỉ",
        "请输入真实姓名": "Hãy điền tên thật",
        "请输入联系电话": "Hảy điền số điện thoại",
        "账号：": "Our Paypal account:",
        "购买成功": "Nạp thành công ",
        "输入的Up号不存在": "Tên Uplive nhập không tồn tại",
        "返回": "Đồng ý",
        "选择银行": "Lựa chọn ngân hàng",
        "邮箱格式错误": "E-Mail bị sai",
        "金额或次数限充": "You have exceeded the daily limit",
        "银行代码": "Mã ngân hàng",
        "银行名称": "Tên ngân hàng",
        "银行汇款": "Chuyển khoản ngân hàng",
        "银行汇款到账提示详情": "Những điều cần biết khi chuyển khoản",
        "错误": "Lỗi",
        "需支付": "Cần chi "
    },
    "zhcn": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "<%=count%>U钻",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "Alfamart充值",
        "Bank Payments": "Bank Payments",
        "Codapay充值": "Codapay充值",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "MyCard充值",
        "PayPal充值": "PayPal充值",
        "PayPal充值不可用，是否前往Vip充值？": "PayPal充值不可用，是否前往Vip充值？",
        "Up号": "Up号",
        "VIP充值": "VIP充值",
        "VIP客服": "VIP客服",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "XenoPay支付",
        "bk_atm支付": "bk_atm支付",
        "bk_card支付": "bk_card支付",
        "cashu支付": "cashu支付",
        "icard_Code": "Code",
        "icard_Please_enter_code_of_the_card": "Please enter code of the card",
        "icard_Please_enter_serial_of_the_card": "Please enter serial of the card",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "onecard支付",
        "paytm": "paytm",
        "个人隐私条款": "个人隐私条款",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "为了保障您的资金安全，PayPal充值将做以下限制：",
        "为确保您能收到发票等信息，请在此处填写手机号和邮箱。": "为确保您能收到发票等信息，请在此处填写手机号和邮箱。",
        "为确保您能收到发票等信息，请在此处填写邮箱。": "为确保您能收到发票等信息，请在此处填写邮箱。",
        "交易中": "交易中",
        "价格": "价格",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "使用CashCard充值所得U钻数将根据兑换比例(<%=currence%><%=real%>=<%=number%>钻)进行换算，最终所得U钻数会进行四舍五入处理",
        "使用CashCard充值的金额数以点卡实际支付的金额为准": "使用CashCard充值的金额数以点卡实际支付的金额为准",
        "信息描述": "信息描述",
        "储值服务时间详情": "银行APP汇款储值转账时间24小时@@@@银行网路汇款储值转帐时间 24小时@@@@ATM转帐储值转帐时间 24小时",
        "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "充值比例: <%=currence%><%=real%>=<%=number%>U钻",
        "充值账号": "充值账号",
        "公司Paypal账号：": "公司Paypal账号：",
        "关于我们": "关于我们",
        "参数错误": "参数错误",
        "取消": "取消",
        "名称：": "名称：",
        "商品": "商品",
        "备注：": "备注：",
        "小贴士": "小贴士",
        "已加赠<%=count%>U钻": "已加赠<%=count%>U钻",
        "微信号": "微信号",
        "微信支付": "微信支付",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。",
        "我已阅读以下条款": "我已阅读以下条款",
        "手机号必填": "手机号必填",
        "手机号格式不正确，请重新填写": "手机号格式不正确，请重新填写",
        "提交成功": "提交成功 ",
        "支付所需资料": "支付所需资料",
        "支付条约": "支付条约",
        "支付结果": "支付结果",
        "数据请求失败": "数据请求失败",
        "更换Up号充值": "更换Up号充值",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；",
        "注意事项详情": "<em>1.</em> 使用任一银行金融卡在跨行 ATM 提款机转帐为15元 手续费。@@@@<em>2.</em> 使用任一银行金融卡在非跨行 ATM 提款机转帐为0元 手续费。@@@@<em>2.</em> 虚拟帐号从生成之时起在 24小时 内有效，超时则无法付款成功。@@@@<em>2.</em> 全年无休，24小时 可用。",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "注意：请仔细核对Up号是否正确，避免充值错误。",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。",
        "知道了": "知道了",
        "确认": "确认",
        "立即充值": "立即充值",
        "第一步：打开Up直播点击个人主页": "第一步：打开Up直播点击个人主页",
        "第二步：查看Up号并输入": "第二步：查看Up号并输入",
        "系统公告": "系统公告",
        "系统错误": "系统错误",
        "线下充值流程：": "线下充值流程：",
        "网络连接有误, 请稍后再试": "网络连接有误, 请稍后再试",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "联系VIP客服进行线下充值，即可享受3%赠钻优惠",
        "联系我们": "联系我们",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "若充值过程中出现U钻未到账情况，请在App内联系官方客服；",
        "请输入Up号": "请输入Up号",
        "请输入手机号": "请输入手机号",
        "请输入邮箱": "请输入邮箱",
        "账号：": "账号：",
        "购买成功": "购买成功",
        "赶快购买礼物向主播表达心意吧": "赶快购买礼物向主播表达心意吧",
        "输入的Up号不存在": "输入的Up号不存在",
        "返回": "返回",
        "退款及取消条款": "退款及取消条款",
        "邮箱格式不正确，请重新填写": "邮箱格式不正确，请重新填写",
        "银行汇款到账提示详情": "<em>1.</em>银行网路汇款储值、ATM储值一般15~60分钟内到帐，其余储值方式的到帐时间为：周一到周四15:30 后汇款需隔天到帐，周五15 : 30 后汇款需下周一到帐。@@@@<em>2.</em> 为维护自身权益，转帐完成后请保留汇款单据。@@@@<em>3.</em> 储值过程中如果遇到任何问题，请联系我们客服。@@@@<em>4.</em>储值金额将一次性转为游戏货币，无法分开帐号或同一帐号分多次储值。",
        "错误": "错误"
    },
    "zhhk": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "1、打開Paypal客户端或Paypal官網，點擊付款，然後輸入公司的Paypal帳號，選擇您所要充值的金額，進行轉帳，轉帳成功後請截圖留證；",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1、線下充值的赠鑽優惠要比線上充值高哦，具體的優惠政策可詢問VIP客服；",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "2、將您轉帳成功的截圖，發给VIP客服（如果暫時没有，可選擇下列的任一VIP客服進行添加），並提供您的Up號；",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2、由於需要先驗證是否到帳，所以發鑽會有些許延遲，但我們會以最快的速度幫您充值，還請您多多理解。",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "3、公司驗證到帳後，會立刻给您發鑽，並通過VIP客服通知您鑽已發放成功。",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "<%=count%>U鑽",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "Alfamart儲值",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "Codapay儲值",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "MyCard儲值",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "Paypal儲值",
        "PayPal充值不可用，是否前往Vip充值？": "PayPal充值不可用，是否前往Vip充值？",
        "Up号": "Up帳號",
        "Up号:": "Up帳號:",
        "VIP充值": "VIP儲值",
        "VIP客服": "VIP客服",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "XenoPay充值",
        "bk_atm支付": "bk_atm儲值",
        "bk_card支付": "bk_card儲值",
        "cashu支付": "cashu付款",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "onecard付款",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "為了保障您的資金安全，PayPal儲值將做以下限制：",
        "交易中": "交易中",
        "价格": "價格",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "使用CashCard儲值所得U鑽數將根據兌換比例(<%=currence%><%=real%>=<%=number%>鑽)進行換算，最終所得U鑽數會進行四捨五入處理",
        "使用CashCard充值的金额数以点卡实际支付的金额为准": "使用CashCard儲值的金額數已點卡實際支付的金額為準",
        "信息描述": "描述說明",
        "充值信息": "充值訊息",
        "充值方式": "充值方式",
        "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "充值比例：<%=currence%><%=real%>=<%=number%>U鑽",
        "充值账号": "充值帳號",
        "充值账号：请仔细核对Up账号是否正确，以避免充值错误": "充值帳號：為防止充值錯誤，請仔細核對Up帳號是否正確",
        "充值账户:": "充值帳戶:",
        "充值金额": "充值金額",
        "充值额度:": "充值額度:",
        "公司Paypal账号：": "公司Paypal帳號：",
        "参数错误": "參數錯誤",
        "发票信息": "發票明細",
        "取消": "取消",
        "名称：": "名稱：",
        "商品": "商品",
        "备注：": "備註：",
        "小贴士": "溫馨提醒",
        "已加赠<%=count%>U钻": "已加贈<%=count%>U鑽",
        "微信号": "微信號",
        "微信支付": "微信充值",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "您好，由於系统升級維護，所以暫時關閉線上充值功能，您可以轉帳至公司帳戶，並通過VIP客服獲取U鑽。",
        "慈善捐款": "慈善捐款",
        "提交，去支付": "確定",
        "支付结果": "支付結果",
        "数据请求失败": "數據請求失敗",
        "更换Up号充值": "更換Up帳號",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "每個Up帳號或PayPal帳號每天限儲5次，且充值總數不能超過16000U鑽。",
        "汇款注意事项": "匯款注意事項",
        "注意事项：": "注意事項：",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "注意：為防止充值錯誤，請仔細核對Up帳號是否正確",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "由此给您帶来的不便，我們會给您更多的贈鑽優惠，也祝您在Uplive玩得愉快，以下是詳細流程。",
        "知道了": "我了解",
        "确认": "確定",
        "立即充值": "立即充值",
        "第一步：打开Up直播点击个人主页": "第一步：打開Uplive，點擊個人頁面",
        "第二步：查看Up号并输入": "第二步：檢閱Up帳號並且輸入",
        "系统公告": "系统公告",
        "系统异常": "系統異常",
        "系统错误": "系統錯誤",
        "索取发票": "索取收據",
        "线下充值流程：": "線下充值流程：",
        "网络连接有误, 请稍后再试": "網路環境異常，請稍候再試",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "聯系VIP客服進行線下儲值，即可享受3%贈鑽優惠",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "若充值過程中出現U鑽未到帳情況，請聯繫官方客服。",
        "请输入Up号": "請輸入Up帳號",
        "请输入e-mail地址": "請輸入e-mail地址",
        "请输入住宅地址": "請輸入住宅地址",
        "请输入真实姓名": "請輸入真實姓名",
        "请输入联系电话": "請輸入手機號碼",
        "账号：": "帳號：",
        "购买成功": "購買成功",
        "输入的Up号不存在": "您所輸入的Up帳號不存在",
        "返回": "返回",
        "选择银行": "選擇銀行",
        "银行汇款": "銀行滙款",
        "错误": "錯誤",
        "需支付": "需支付"
    },
    "zhtw": {
        "1、打开Paypal客户端或Paypal官网，点击付款，然后输入公司的Paypal账号，选择您所要充值的金额，进行转账，转账成功后请截图留证；": "1、打開Paypal客户端或Paypal官網，點擊付款，然後輸入公司的Paypal帳號，選擇您所要充值的金額，進行轉帳，轉帳成功後請截圖留證；",
        "1、线下充值的赠钻优惠要比线上充值高哦，具体的优惠政策可询问VIP客服；": "1、線下充值的赠鑽優惠要比線上充值高哦，具體的優惠政策可詢問VIP客服；",
        "2、将您转账成功的截图，发给VIP客服（如果暂时没有，可选择下列的任一VIP客服进行添加），并提供您的Up号；": "2、將您轉帳成功的截圖，發给VIP客服（如果暫時没有，可選擇下列的任一VIP客服進行添加），並提供您的Up號；",
        "2、由于需要先验证是否到账，所以打钻会有些许延迟，但我们会以最快的速度帮您充值，还请您多多理解。": "2、由於需要先驗證是否到帳，所以發鑽會有些許延遲，但我們會以最快的速度幫您充值，還請您多多理解。",
        "3、公司验证到账后，会立刻给您打钻，并通过VIP客服通知您钻已发放成功。": "3、公司驗證到帳後，會立刻给您發鑽，並通過VIP客服通知您鑽已發放成功。",
        "7-Eleven": "7-Eleven",
        "7-Eleven PH": "7-Eleven PH",
        "<%=count%>U钻": "<%=count%>U鑽",
        "ATM Transfer": "ATM Transfer",
        "Alfamart": "Alfamart",
        "Alfamart充值": "Alfamart儲值",
        "Bank Payments": "Bank Payments",
        "CashCard(IDR)": "CashCard(IDR)",
        "CashCard(THB)": "CashCard(THB)",
        "Codapay充值": "Codapay儲值",
        "Counter Payments": "Counter Payments",
        "Direct Carrier Billing": "Direct Carrier Billing",
        "Doku Wallet": "Doku Wallet",
        "GCash": "GCash",
        "GO-PAY": "GO-PAY",
        "Indomaret": "Indomaret",
        "Line": "Line",
        "MoMo": "MoMo",
        "MyCard充值": "MyCard儲值",
        "OnlineBank(IDR)": "OnlineBank(IDR)",
        "PayPal充值": "Paypal儲值",
        "PayPal充值不可用，是否前往Vip充值？": "PayPal充值不可用，是否前往Vip充值？",
        "Up号": "Up帳號",
        "Up号:": "Up帳號:",
        "VIP充值": "VIP儲值",
        "VIP客服": "VIP客服",
        "Whatsapp": "Whatsapp",
        "XenoPay支付": "XenoPay儲值",
        "bk_atm支付": "bk_atm儲值",
        "bk_card支付": "bk_card儲值",
        "cashu支付": "cashu付款",
        "iCard": "iCard",
        "icard_Code": "Code",
        "icard_Serial": "Serial",
        "icard_cardType": "CardType",
        "icard_cardValue": "CardValue",
        "icard_popup_confirm_title": "The information below is correct?",
        "icard_popup_no": "No",
        "icard_popup_yes": "Yes",
        "molpay_credit_card": "MOLPay Credit Card",
        "molpay_points": "zGOLD-MOLPoints",
        "onecard支付": "onecard付款",
        "paytm": "paytm",
        "为了保障您的资金安全，PayPal充值将做以下限制：": "為了保障您的資金安全，PayPal儲值將做以下限制：",
        "云智联网络科技": "網易收服務ATM專戶",
        "交易中": "交易中",
        "价格": "價格",
        "使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理": "使用CashCard儲值所得U鑽數將根據兌換比例(<%=currence%><%=real%>=<%=number%>鑽)進行換算，最終所得U鑽數會進行四捨五入處理",
        "使用CashCard充值的金额数以点卡实际支付的金额为准": "使用CashCard儲值的金額數已點卡實際支付的金額為準",
        "信息描述": "描述說明",
        "储值服务时间详情": "銀行APP匯款儲值轉帳時間24小時@@@@網路銀行匯款儲值轉帳時間 24小時@@@@ATM轉帳儲值時間 24小時",
        "储值服务时间：": "儲值服務時間：",
        "充值信息": "儲值訊息",
        "充值方式": "儲值方式",
        "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "儲值比例：<%=currence%><%=real%>=<%=number%>U鑽",
        "充值账号": "儲值帳號",
        "充值账号：请仔细核对Up账号是否正确，以避免充值错误": "儲值帳號：請仔細核對Up帳號是否正確，以避免儲值錯誤",
        "充值账户:": "儲值帳戶:",
        "充值金额": "儲值金額<em>(ATM In 最優惠)</em>",
        "充值额度:": "儲值額度:",
        "公司Paypal账号：": "公司Paypal帳號：",
        "参数错误": "參數錯誤",
        "发票信息": "發票明細",
        "取消": "取消",
        "名称：": "名稱：",
        "商品": "商品",
        "备注：": "備註：",
        "小贴士": "溫馨提醒",
        "已加赠<%=count%>U钻": "已加贈<%=count%>U鑽",
        "微信号": "微信號",
        "微信支付": "微信儲值",
        "您好，由于系统升级维护，暂时关闭线上充值功能，您可以转账至公司帐户，并通过VIP客服获取u钻。": "您好，由於系统升級維護，暫時關閉線上充值功能，您可以轉帳至公司帳戶，並通過VIP客服獲取u鑽。",
        "慈善捐款": "慈善捐款",
        "慈善捐赠解释": "<em>1.慈善捐贈：</em>我們會將您的愛心傳遞給社會財團法人中華民國保護動物協會，謝謝您！網址：http://apate.org/",
        "户名": "戶名",
        "提交，去支付": "確定",
        "支付结果": "匯款結果",
        "数据请求失败": "無法取得正確資訊",
        "更换Up号充值": "更換Up帳號",
        "最优": "最優",
        "每个Up账号或PayPal账号每天限充5次，且充值总数不能超过16000U钻；": "每個Up帳號或PayPal帳號每天限儲5次，且儲值總數不能超過16000U鑽。",
        "永兴银行": "永豐銀行",
        "汇款注意事项": "匯款注意事項",
        "汇款账户": "匯款帳號",
        "汇款账户信息": "匯款帳號訊息",
        "汇款金额": "匯款金額",
        "注意事项详情": "<em>1.</em> 使用任一銀行金融卡在跨行 ATM 提款機轉帳為15元手續費。@@@@<em>2.</em> 使用任一銀行金融卡在非跨行 ATM 提款機轉帳為0元手續費。@@@@<em>3.</em> 虛擬帳號從生成之時起在24小時內有效，超時則無法付款成功。@@@@<em>4.</em> 全年無休，24小時可用。@@@@<em>5.</em>分行別為：永豐銀行台北分行",
        "注意事项：": "注意事項：",
        "注意：请仔细核对Up号是否正确，避免充值错误。": "注意：請仔細核對Up帳號是否正確，以避免儲值錯誤",
        "由此给您带来的不便，我们会给您更大的赠钻优惠，也祝您在Up玩得愉快，以下是详细流程。": "由此给您帶来的不便，我們會给您更大的贈鑽優惠，也祝您在Up玩得愉快，以下是詳細流程。",
        "电话号码格式错误": "手機號碼格式錯誤",
        "知道了": "我了解",
        "确定": "確定",
        "确认": "確定",
        "确认充值": "確認儲值",
        "立即充值": "立即儲值",
        "第一步：打开Up直播点击个人主页": "第一步：打開Up帳號點擊個人頁面",
        "第二步：查看Up号并输入": "第二步：檢閱Up帳號並且輸入",
        "系统公告": "系统公告",
        "系统异常": "系統異常",
        "系统错误": "系統錯誤",
        "索取发票": "索取發票",
        "索取发票解释": "<em>2.索取發票：</em>我們將於15個工作天內郵寄給您發票！",
        "线下充值流程：": "線下充值流程：",
        "网络连接有误, 请稍后再试": "網路環境異常，請稍候再試",
        "联系VIP客服进行线下充值，即可享受3%赠钻优惠": "聯系VIP客服進行線下儲值，即可享受3%贈鑽優惠",
        "若充值过程中出现U钻未到账情况，请在App内联系官方客服；": "若儲值過程中出現U鑽未到帳情況，請聯繫官方客服。",
        "请您于24小时内通过线下银行汇款的方式转账至上述银行账户，逾期将无法付款成功": "請您於24小時內通過線下銀行匯款的方式轉帳至上述銀行帳戶，逾期將無法付款成功",
        "请输入Up号": "請輸入Up帳號",
        "请输入e-mail地址": "請輸入e-mail地址",
        "请输入住宅地址": "請輸入住宅地址",
        "请输入真实姓名": "請輸入真實姓名",
        "请输入联系电话": "請輸入手機號碼",
        "账号：": "帳號：",
        "购买成功": "購買成功",
        "输入的Up号不存在": "您輸入的Up帳號並不存在",
        "返回": "返回",
        "选择银行": "選擇銀行",
        "邮箱格式错误": "信箱格式錯誤",
        "金额或次数限充": "超過今日購買限制",
        "银行代码": "銀行代碼",
        "银行名称": "銀行名稱",
        "银行汇款": "快速儲值",
        "银行汇款到账提示详情": "<em>1.</em>銀行網路匯款儲值、ATM儲值一般15~60分鐘內到帳，其餘儲值方式的到帳時間為：周一到周四15:30 後匯款需隔天到帳，周五15 : 30 後匯款需下周一到帳。@@@@<em>2.</em> 為維護自身權益，轉帳完成後請保留匯款單據。@@@@<em>3.</em> 儲值過程中如果遇到任何問題，請聯繫我們客服。@@@@<em>4.</em>儲值金額將一次性轉為平台貨幣，無法分開帳號或同一帳號分多次儲值。",
        "错误": "錯誤",
        "需支付": "需匯款"
    }
}


// WEBPACK FOOTER //
// ./js/lang/pack.js